const marketplaceRouterPaths = {
  root: '/marketplace',
};

export default marketplaceRouterPaths;
